import type { NgModuleRef } from '@angular/core';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { ENVIRONMENT } from '@recruitee/common';
import { PHRASE_APP_TRANSLATIONS } from '@recruitee/i18n';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.angularProdMode) {
  enableProdMode();
}

const bootstrap = async () => {
  const ngModule: NgModuleRef<any> = await platformBrowserDynamic([
    {
      provide: PHRASE_APP_TRANSLATIONS,
      useValue: [{ en: {} }],
    },
    { provide: ENVIRONMENT, useValue: environment },
  ]).bootstrapModule(AppModule, {
    ngZone: 'noop',
  });

  return ngModule;
};

bootstrap();
